import { Routes } from "@angular/router";
import { BriTeammateLoginComponent } from "@davita/bridge-utility-library/login";

export const routes: Routes = [
  { path: "", redirectTo: "dashboard", pathMatch: "full" },
  {
    path: "teammate-login",
    component: BriTeammateLoginComponent,
  },
  {
    path: "",
    loadChildren: () =>
      import("./features/dashboard/dashboard.routes").then(
        (m) => m.DASHBOARD_ROUTES,
      ),
  },
  {
    path: "",
    loadChildren: () =>
      import("./features/prototype/prototype.routes").then(
        (m) => m.PROTOTYPE_ROUTES,
      ),
  },
  {
    path: "",
    loadChildren: () =>
      import("./features/lab/lab.routes").then((m) => m.LAB_ROUTES),
  },
  {
    path: "",
    loadChildren: () =>
      import("./features/manage/manage.routes").then((m) => m.MANAGE_ROUTES),
  },
];
